import { useDispatch, useSelector } from "react-redux";
import { ApiMediaURL } from "../../../../setting/GlobleVariable";
import {
  DeleteUserProfiel,
  UpdateUserRole,
} from "../../../../redux/actions/Admin/AdminUser";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AVATAR_COLORS = ["#E52324", "#3B82F6", "#8B5CF6", "#10B981", "#F59E0B"];

function avatarColor(seed = "") {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash += seed.charCodeAt(i);
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

function roleBadgeClass(role) {
  return role === "admin"
    ? "bg-red-500/15 text-red-400"
    : "bg-emerald-500/15 text-emerald-400";
}

const thClass =
  "text-left px-5 py-3 text-[10px] text-[#E52324] uppercase tracking-widest";
const tdMuted = "px-5 py-3 text-[11px] text-white/40";

const ClientTable = () => {
  const adminUsers = useSelector((state) => state.user.AdminAllUser)
    ?.slice(-5)
    ?.reverse();
  const dispatch = useDispatch();

  const handleDeleteUser = (id) => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(DeleteUserProfiel(id));
      }
    });
  };

  return (
    <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl mb-6">
      <div className="px-5 py-4 border-b border-[#1a2744]">
        <h3 className="text-white text-[16px]" style={{ fontWeight: 700 }}>
          New User
        </h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#1a2744]">
              <th className={thClass} style={{ fontWeight: 700 }}>
                #
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Avatar/Name
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Email
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Mobile Number
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Role
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Created_at
              </th>
              <th className={thClass} style={{ fontWeight: 700 }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {adminUsers?.map((item, index) => {
              const name = item?.firstName || item?.email || "User";
              const initial = name.charAt(0).toUpperCase();

              return (
                <tr
                  key={item?._id || index}
                  className="border-b border-[#1a2744]/50 hover:bg-[#1a2744]/30 transition-colors"
                >
                  <td className="px-5 py-3 text-[12px] text-white/40">{index + 1}</td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2.5">
                      {item?.Avatar ? (
                        <img
                          src={`${ApiMediaURL}/${item.Avatar}`}
                          alt=""
                          className="w-7 h-7 rounded-full object-cover"
                          loading="lazy"
                        />
                      ) : (
                        <div
                          className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] text-white"
                          style={{
                            fontWeight: 700,
                            background: avatarColor(name),
                          }}
                        >
                          {initial}
                        </div>
                      )}
                      <span className="text-[12px] text-white" style={{ fontWeight: 600 }}>
                        {name}
                      </span>
                    </div>
                  </td>
                  <td className={tdMuted}>{item?.email}</td>
                  <td className={tdMuted}>{item?.phoneNumber}</td>
                  <td className="px-5 py-3">
                    <button
                      type="button"
                      onClick={() =>
                        dispatch(
                          UpdateUserRole(
                            item?._id,
                            item?.role === "user" ? "admin" : "user"
                          )
                        )
                      }
                      className={`px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider cursor-pointer border-0 ${roleBadgeClass(
                        item?.role
                      )}`}
                      style={{ fontWeight: 600 }}
                    >
                      {item?.role}
                    </button>
                  </td>
                  <td className={tdMuted}>{item?.createdAt?.slice(0, 10)}</td>
                  <td className="px-5 py-3">
                    <button
                      type="button"
                      onClick={() => handleDeleteUser(item?._id)}
                      className="text-[10px] text-white/30 hover:text-white px-2.5 py-1 rounded border border-[#243354] hover:bg-[#1a2744] transition-all"
                    >
                      Options
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientTable;
